declare global {
  interface Window {
    Capacitor?: { isNativePlatform?: () => boolean; DEBUG?: boolean };
  }
}

/* Read from the global the native bridge injects, so the web bundle never imports @capacitor/core to ask. */
export const isNativeShell = (): boolean =>
  window.Capacitor?.isNativePlatform?.() === true;
